import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {KfReportCyclesComponent} from './containers/kf-report-cycles/kf-report-cycles.component';
import {KfNextReportCycleComponent} from './containers/kf-next-report-cycle/kf-next-report-cycle.component';
import {ClassifiersComponent} from './containers/classifiers/classifiers.component';
import {KfRegistrationAdminComponent} from './containers/kf-registration-admin/kf-registration-admin.component';
import {KfRegistrationValidationComponent} from './containers/kf-registration-validation/kf-registration-validation.component';
import {KfConfigurationAdminComponent} from './containers/kf-configuration-admin/kf-configuration-admin.component';
import {KfReportingGuard} from './guards/kf-reporting.guard';

const routes: Routes = [
  {
    path: 'kfreporting', canActivate: [KfReportingGuard],
    children: [
      {path: 'kfconfiguration', children: [
          {path: 'reportcycles', component: KfReportCyclesComponent},
          {path: 'nextreportcycle', component: KfNextReportCycleComponent},
          {path: 'configurations', component: KfConfigurationAdminComponent}
        ]
      },
      {path: 'classifiers', children: [
          {path: 'unu-keys', component: ClassifiersComponent},
          {path: 'kf-categories', component: ClassifiersComponent},
          {path: 'collection-streams', component: ClassifiersComponent},
        ]
      },
      {path: 'kfregistration', children: [
          {path: 'all-registrations', component: KfRegistrationAdminComponent},
          {path: 'validation-center', component: KfRegistrationAdminComponent},
          {path: 'validate/:keyFigures/:referenceId', component: KfRegistrationValidationComponent},
        ]
      },
    ]
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class KfReportingRoutingModule { }
